module.exports = __webpack_public_path__ + "static/media/loading.8ba8ce24.gif";